import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import getMemberTaskGroups from './useMemberTaskGroups.request';

import { TaskGroupSummary } from 'modules/Tasks/types';

export const MEMBER_TASK_GROUPS_QUERY_KEY = ['memberTaskGroups'] as const;

export default function useMemberTaskGroups<TData = TaskGroupSummary[]>(
    location?: string,
    options?: Omit<UseQueryOptions<TaskGroupSummary[], AxiosError, TData>, 'queryKey' | 'queryFn'>
) {
    return useQuery({
        queryKey: [...MEMBER_TASK_GROUPS_QUERY_KEY, { location }],
        queryFn: () => getMemberTaskGroups(location),
        staleTime: 1000 * 60 * 5, // 5 minutes
        refetchOnWindowFocus: false,
        refetchOnMount: 'always',
        ...options,
    });
}
